import { render, staticRenderFns } from "./sso.vue?vue&type=template&id=506a3015"
import script from "./sso.vue?vue&type=script&lang=js"
export * from "./sso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('506a3015')) {
      api.createRecord('506a3015', component.options)
    } else {
      api.reload('506a3015', component.options)
    }
    module.hot.accept("./sso.vue?vue&type=template&id=506a3015", function () {
      api.rerender('506a3015', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/login/sso.vue"
export default component.exports